<div class="spinner">
  <div class="fa-3x">
    <i class="fas fa-spinner-third fa-spin"></i>
  </div>
</div>